var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-header',{attrs:{"data-toggle":"collapse","data-parent":"#accordion","href":_vm.isNew ? '#newbranchoffice' : '#branchoffice'+_vm.branchoffice.id}},[_c('h6',[_vm._v(" "+_vm._s(_vm.isNew ? 'Nueva Sucursal' : 'Sucursal ' + _vm.branchoffice.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }